<template>
  <v-container
    fluid
  >
    <material-card
      heading="로그"
      icon-small
      icon="mdi-database"
      title="로그"
      color="primary"
    >
      <v-card-text class="py-0">
        <v-row>
          <v-spacer />
          <v-col
            cols="6"
            xl="1"
          >
            <v-select
              v-model="filter.type"
              dense
              outlined
              :items="types"
            />
          </v-col>
          <v-col
            cols="6"
            xl="1"
          >
            <v-menu
              v-model="menu1"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="filter.startDate"
                  label="시작일"
                  persistent-hint
                  readonly
                  outlined
                  dense
                  v-bind="attrs"
                  v-on="on"
                />
              </template>
              <v-date-picker
                v-model="filter.startDate"
                no-title
                @input="menu1 = false"
                @change="startDateChanged"
              />
            </v-menu>
          </v-col>
          <v-col
            cols="6"
            xl="1"
          >
            <v-menu
              v-model="menu2"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="filter.endDate"
                  label="종료일"
                  persistent-hint
                  readonly
                  outlined
                  dense
                  v-bind="attrs"
                  v-on="on"
                />
              </template>
              <v-date-picker
                v-model="filter.endDate"
                no-title
                :allowed-dates="allowedEndDates"
                @input="menu2 = false"
              />
            </v-menu>
          </v-col>
          <v-col
            cols="6"
            xl="1"
          >
            <v-btn
              dense
              color="primary"
              @click="getLogs(true)"
            >
              <v-icon>
                mdi-magnify
              </v-icon>
              검색
            </v-btn>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <v-timeline
              v-if="logs.length > 0"
              dense
            >
              <v-slide-x-reverse-transition
                group
                hide-on-leave
              >
                <v-timeline-item
                  v-for="item in logs"
                  :key="item._id"
                  :color="colors[item.type]"
                  small
                  fill-dot
                >
                  <v-alert
                    outlined
                    dense
                    :value="true"
                    :color="colors[item.type]"
                    :icon="icons[item.type]"
                    class="white--text"
                  >
                    {{ item.text }} / {{ item.created | formatDate }}
                  </v-alert>
                </v-timeline-item>
              </v-slide-x-reverse-transition>
            </v-timeline>
            <v-alert
              v-else
              border="left"
              colored-border
              type="error"
              elevation="2"
            >
              조회된 로그가 없습니다.
            </v-alert>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <v-container class="max-width">
              <v-pagination
                v-if="logs.length > 0"
                v-model="page"
                class="my-4"
                :total-visible="totalVisible"
                :length="pageCount"
              />
            </v-container>
          </v-col>
        </v-row>
      </v-card-text>
    </material-card>
  </v-container>
</template>

<script>
  import moment from 'moment'

  export default {
    data: () => ({
      menu1: false,
      menu2: false,
      types: [
        { text: '전체', value: '-1' },
        { text: '예약', value: 'r' },
        { text: '관리자', value: 'a' },
        { text: '시스템', value: 's' },
      ],
      filter: {
        type: '-1',
        startDate: moment().format('YYYY-MM-DD'),
        endDate: moment().format('YYYY-MM-DD'),
      },
      logs: [],
      page: 1,
      pageCount: 1,
      totalVisible: 7,
      colors: {
        a: 'info',
        s: 'warning',
        r: 'success',
      },
      icons: {
        a: 'mdi-information',
        s: 'mdi-alert',
        r: 'mdi-check-circle',
      },
    }),

    watch: {
      page: {
        handler (val) {
          this.getLogs(false)
        },
      },
    },

    mounted () {
      this.getLogs(true)
    },

    methods: {
      async getLogs (isSearch) {
        const params = {
          type: this.filter.type,
          startDtime: moment(`${this.filter.startDate} 00:00:00`).utc().format('YYYY-MM-DDTHH:mm:ss') + 'Z',
          endDtime: moment(`${this.filter.endDate}`).add(1, 'days').utc().format('YYYY-MM-DDTHH:mm:ss') + 'Z',
        }

        if (isSearch) {
          this.page = 1
          const logCounts = (await this.$http.get('/api/v1/logs/counts', { params: params })).data
          this.pageCount = parseInt(logCounts / 10) + ((logCounts % 10) > 0 ? 1 : 0)
          this.totalVisible = this.pageCount > 7 ? 7 : this.pageCount
        }

        const dataParams = {
          ...params,
          skip: (this.page - 1) * 10,
          limit: 10,
        }
        this.logs = (await this.$http.get('/api/v1/logs', { params: dataParams })).data
      },
      startDateChanged () {
        if (moment(this.filter.startDate) > moment(this.filter.endDate)) {
          this.filter.endDate = this.filter.startDate
        }
      },
      allowedEndDates (d) {
        return moment(d).format('YYYY-MM-DD') >= moment(this.filter.startDate).format('YYYY-MM-DD')
      },
    },
  }
</script>

<style scoped>

</style>
